// ----------------------------------------------------------------------

export default function Card(theme) {
  if (theme.mode === 'light') return {};

  return {
    MuiCard: {
      styleOverrides: {
        root: {
          position: 'relative',
          background: "hsla(0, 0%, 5%, .2)", // Slightly lighter dark background for contrast
          backdropFilter: "blur(1px) saturate(150%)", // Moderate blur for smooth glass effect
          WebkitBackdropFilter: "blur(1px) saturate(150%)",
          boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)", // Low subtle shadow
          borderRadius: Number(theme.shape.borderRadius) *2 ,
          zIndex: 0, // Fix Safari overflow: hidden with border radius
        },
      },
    },
    MuiCardHeader: {
      defaultProps: {
        titleTypographyProps: { variant: 'h6' },
        subheaderTypographyProps: { variant: 'body2', marginTop: theme.spacing(0.5) },
      },
      styleOverrides: {
        root: {
          padding: theme.spacing(3, 3, 0),
        },
      },
    },
    MuiCardContent: {
      styleOverrides: {
        root: {
          padding: theme.spacing(3),
        },
      },
    },
  };
}
